import { COLLECT_COMPAT } from '@/api/apiModules'

export default {
  viewType: 'table',
  module: COLLECT_COMPAT,
  listUrl: `${COLLECT_COMPAT}/listCompatibleRecord`,
  params: null,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: 'pocMng.searchCompatiblePlaceholder',
    searchFieldNameArr: ['productVersion', 'os', 'createUser']
  },
  view: {
    columns: [
      {
        props: {
          label: '兼容状态',
          prop: 'compatibleStatus',
          sortField: 'compatibleStatus',
          width: 120
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '产品版本',
          prop: 'productVersion'
        }
      },
      {
        props: {
          label: '操作系统',
          prop: 'os'
        }
      },
      {
        props: {
          label: '兼容性信息',
          prop: 'limitDesc'
        }
      },
      {
        props: {
          label: '兼容性测试文档',
          prop: 'verificationName',
          width: 240
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }

          let vNode = [
            <div class="wsp-display-flex-center">
              <div
                class="sk-link--normal"
                on-click={$event => {
                  this.$store.dispatch('customDownloadDocument', {
                    module: COLLECT_COMPAT,
                    params: {
                      id: data.id
                    },
                    action: 'downloadVerification'
                  })
                }}
              >
                <span>{data.verificationName}</span>
              </div>
            </div>
          ]

          if (data.verificationName) {
            return vNode
          }
          return
        }
      },
      {
        props: {
          label: '上报时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 170
        },
        dataType: 'date'
      },
      {
        props: {
          label: '上报人',
          prop: 'createUser',
          sortField: 'createUser',
          width: 100
        }
      }
    ]
  }
}
